const Address = ({
    street = '',
    city = '',
    state = '',
    zip = '',
    unit = '',
}) => ({
    street: String(street),
    city: String(city),
    state: String(state),
    zip: String(zip),
    unit: String(unit),
});

const FloorPlan = ({
    aliasEncoded = '',
    address = {},
}) => ({
    aliasEncoded: String(aliasEncoded),
    address: Address(address),
});

const SimilarFloorPlan = ({
    lowestPriceIncluded = 0,
    highestPriceIncluded = 0,
    floorplans = [],
}) => ({
    lowestPriceIncluded: Number(lowestPriceIncluded),
    highestPriceIncluded: Number(highestPriceIncluded),
    floorplans: floorplans.map(item => item),
});

const ListingComps = ({
    floorplans = [{}],
    similarFloorplans = {},
}) => ({
    floorplans: floorplans.map(item => FloorPlan(item)),
    similarFloorplans: SimilarFloorPlan(similarFloorplans),
});

export default ListingComps;
